import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useBasePath } from './utils/utilities';
import usePageView from './hooks/usePageView';

export default function ThankYou() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const basePath = useBasePath();

    usePageView();

    return (
        <div className="advices-suisse">
            <h2 className="beta-heading advices-suisse__main-title">
                {t('Request free quotation')}
            </h2>

            <div className="advices-suisse__links">
                <button
                    className="advices-suisse__back-button"
                    type={'button'}
                    onClick={() => navigate(`${basePath}/`)}
                >
                    {t('< Back')}
                </button>
            </div>

            <div>
                <p className="offerform__thanks">
                    {t(
                        'Thank you for your application. One of our qualified innovation partners will be in touch with you soon for a personal offer.'
                    )}
                </p>
            </div>
        </div>
    );
}
